// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';
  $('#oc-container .card--multi-toggle').each((key, item) => {
    const $imageList = $(item).find('.multi-toggle__img-list');
    const $tabsWrapper = $(item).find('.multi-toggle__tabs');
    const $tabsIndicator = $(item).find('.multi-toggle__tabs-indicator');

    $imageList.on('init', (event, slick) => {
      event.stopPropagation();
      $tabsIndicator.width(`${100 / slick.slideCount}%`);
    });

    $imageList.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      event.stopPropagation();
      const $el = slick.$slides.eq(nextSlide);
      window.handleClickTracking($el);
      $tabsIndicator.css(
        'transform',
        `translateX(${isRTL ? '-' : ''}${100 * nextSlide}%)`
      );
    });

    // init slick
    $imageList.slick({
      arrows: false,
      swipe: false,
      fade: true,
      dots: true,
      rtl: isRTL,
      appendDots: $tabsWrapper,
      customPaging: (slick, index) => {
        const name = slick.$slides.eq(index).data('name');
        return `<button class="multi-toggle__tab">${name}</button>`;
      },
    });
  });
});
